var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-circle",
    transform: "translate(-26.5 -12.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    transform: "translate(20 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M9,16.15A.85.85,0,0,1,8.4,14.7l6.3-6.3a.85.85,0,0,1,1.2,1.2L9.6,15.9A.847.847,0,0,1,9,16.15Z",
    transform: "translate(-1.65 -1.65)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M15.3,16.15a.847.847,0,0,1-.6-.249L8.4,9.6A.85.85,0,0,1,9.6,8.4l6.3,6.3a.85.85,0,0,1-.6,1.451Z",
    transform: "translate(-1.65 -1.65)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle2);
export default __webpack_public_path__ + "static/media/x-circle-2.05564ebcbd79bf18090cd9c0f6fed295.svg";
export { ForwardRef as ReactComponent };